import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ref", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import ButtonCore from 'components/ButtonCore';
import { jsx as _jsx } from "react/jsx-runtime";
var constantClassName = 'BlockLink';
var StyledBlockLink = styled(ButtonCore).attrs({
  className: constantClassName
}).withConfig({
  displayName: "BlockLink__StyledBlockLink",
  componentId: "sc-1ev9ppl-0"
})(["display:block;width:100%;color:inherit;text-decoration:none;&:not(.is-disabled){cursor:pointer;}"]);
export var Highlight = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'stealthy';
  }
}).withConfig({
  displayName: "BlockLink__Highlight",
  componentId: "sc-1ev9ppl-1"
})(["color:", ";transition:color 0.25s ease-in;.", ":hover &,.", ":focus &{color:", ";text-decoration:", ";}.", ":focus &{text-decoration:underline;}"], function (p) {
  return p.stealthy ? 'inherit' : p.theme.links;
}, constantClassName, constantClassName, function (p) {
  return p.theme.links;
}, function (p) {
  return p.stealthy ? 'none' : 'underline';
}, constantClassName);
export var BlockLink = function BlockLink(_ref) {
  var ref = _ref.ref,
    as = _ref.as,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'a';
  return /*#__PURE__*/_jsx(StyledBlockLink, _objectSpread({
    ref: ref,
    forwardedAs: Component
  }, otherProps));
};
BlockLink.displayName = 'BlockLink';

/* Highlight component for simple link colour highlights */
BlockLink.Highlight = Highlight;

/* BlockLink className for creating CSS selectors for custom Highlight components */
BlockLink.constantClassName = constantClassName;
export default BlockLink;